import { Injectable } from '@angular/core';
import { BaseController } from '@app/common/modules/base/base.controller';  
import { MultaModel } from '@app/data/multas/models';
import { MultaRepository } from '@app/data/multas/multa.repository';

@Injectable()
export class MultasController extends BaseController<MultaModel> {
  constructor(multasRepository: MultaRepository) {
    super(multasRepository);
  }
}
